
import pageHeader from './header/index.vue'
// import navBar from './navbar/index.vue'
import { defineComponent } from 'vue'

export default defineComponent({
    components: {
        pageHeader,
        // navBar,
    },
})
